(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (function () {
    function findQtyInput(form) {
      if (!form) return null;
      return form.querySelector('input[name="quantity"]') ||
             form.querySelector('quantity-selector-component input') ||
             form.querySelector('.quantity-selector input') ||
             form.querySelector('input[type="number"]');
    }

    function buildMessageN(hint, qty) {
      const stock = parseInt(hint.dataset.stock || '0', 10);
      const start = hint.dataset.deliveryStart || '';
      const end = hint.dataset.deliveryEnd || '';
      const overage = qty - stock;
      const stockWord = stock === 1 ? 'unit' : 'units';
      const overWord = overage === 1 ? 'unit' : 'units';
      return '<strong>This order ships in 2 shipments.</strong>' +
        '<span class="overqty-hint__detail">' +
        stock + ' ' + stockWord + ' ship now from in-stock inventory. ' +
        'The remaining ' + overage + ' ' + overWord + ' are special-order, ' +
        'arriving <strong>' + start + ' &ndash; ' + end + '</strong>.' +
        '</span>' +
        '<ul class="overqty-hint__terms">' +
        '<li>Special-order units are non-refundable</li>' +
        '</ul>';
    }

    function buildMessageY(hint, qty) {
      const stock = parseInt(hint.dataset.stock || '0', 10);
      const start = hint.dataset.deliveryStart || '';
      const end = hint.dataset.deliveryEnd || '';
      const overage = qty - stock;
      const stockWord = stock === 1 ? 'unit' : 'units';
      const overWord = overage === 1 ? 'unit' : 'units';
      return '<strong>This order ships in 2 shipments.</strong>' +
        '<span class="overqty-hint__detail">' +
        stock + ' ' + stockWord + ' ship now from in-stock inventory. ' +
        'The remaining ' + overage + ' ' + overWord + ' are available to order, ' +
        'arriving <strong>' + start + ' &ndash; ' + end + '</strong>.' +
        '</span>';
    }

    // Currently selected variant id (matches the add-to-cart form's hidden input).
    function c4SelectedVariantId() {
      const input = document.querySelector('product-form-component input[name="id"]') ||
                    document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]') ||
                    document.querySelector('input[name="id"][ref="variantId"]');
      return input && input.value ? String(input.value) : null;
    }

    // Read the selected variant's live data from the same per-variant JSON the
    // stock badge uses, so the two banners always agree. Returns null if the
    // badge/variant data isn't on the page (then we fall back to data-stock).
    function c4CurrentVariant() {
      const s = document.querySelector('.same-day-ship-badge__variants');
      const vid = c4SelectedVariantId();
      if (!s || !vid) return null;
      try {
        const arr = JSON.parse(s.textContent || '[]');
        for (let i = 0; i < arr.length; i++) {
          if (String(arr[i].id) === vid) return arr[i];
        }
      } catch (e) {}
      return null;
    }

    function updateHint(hint) {
      const formId = hint.dataset.formId;
      const form = formId ? document.getElementById(formId) : hint.closest('form');
      const input = findQtyInput(form);
      const textEl = hint.querySelector('.overqty-hint__text');
      if (!input || !textEl) return;

      // Sync stock + type to the CURRENTLY selected variant (live), so this
      // banner can never disagree with the "only X left" stock badge.
      const v = c4CurrentVariant();
      if (v) {
        const liveStock = (v.tracked && parseInt(v.qty, 10) > 0) ? parseInt(v.qty, 10) : 0;
        hint.dataset.stock = String(liveStock);
        if (v.stk === 'N' || v.stk === 'Y') {
          hint.dataset.hintType = v.stk;
        }
      }

      const stock = parseInt(hint.dataset.stock || '0', 10);
      const type = hint.dataset.hintType || 'N';
      const qty = parseInt(input.value || '1', 10);

      // Only for a genuine split: there IS stock and you ordered more than it.
      // Fully out-of-stock items are covered by the "Available to order" badge.
      if (qty > stock && stock > 0) {
        textEl.innerHTML = (type === 'Y') ? buildMessageY(hint, qty) : buildMessageN(hint, qty);
        hint.hidden = false;
      } else {
        hint.hidden = true;
      }
    }

    function initHints() {
      const hints = document.querySelectorAll('.overqty-hint');
      hints.forEach(function (hint) {
        const formId = hint.dataset.formId;
        const form = formId ? document.getElementById(formId) : hint.closest('form');
        const input = findQtyInput(form);
        if (input && !input.dataset.overqtyBound) {
          input.dataset.overqtyBound = '1';
          ['input', 'change', 'keyup'].forEach(function (evt) {
            input.addEventListener(evt, function () { updateHint(hint); });
          });
          if (form) {
            form.addEventListener('click', function () {
              setTimeout(function () { updateHint(hint); }, 50);
            });
          }
        }
        updateHint(hint);
      });

      // Variant changes (option swatches) fire outside the product form, so
      // bind document-level listeners + a low-cost poll once to keep every
      // hint in sync with the selected variant — no page refresh needed.
      if (!window.__c4OverqtyBound) {
        window.__c4OverqtyBound = true;
        function c4RefreshHints() {
          document.querySelectorAll('.overqty-hint').forEach(updateHint);
        }
        document.addEventListener('change', function () { setTimeout(c4RefreshHints, 200); }, true);
        document.addEventListener('click', function () { setTimeout(c4RefreshHints, 200); }, true);
        setInterval(c4RefreshHints, 500);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHints);
    } else {
      initHints();
    }
    document.addEventListener('shopify:section:load', initHints);
  })();
  } catch(e) { console.error(e); }
})();

})();
